import React from "react";

import Price from "@atoms/Price";

interface IProps {
  autoDiscountAmount?: number;
  codeDiscountAmount?: number;
  codeDiscountTitle: string;
  autoDiscountTitle: string;
}

export default function Discounts({ autoDiscountAmount = 0, codeDiscountAmount = 0, codeDiscountTitle, autoDiscountTitle }: IProps) {
  return (
    <>
      {autoDiscountAmount + codeDiscountAmount > 0 && (
        <>
          <div className="flex justify-between">
            <span>Discount</span>
            <Price isNegative price={autoDiscountAmount + codeDiscountAmount} />
          </div>

          {autoDiscountAmount > 0 && (
            <div className="flex justify-between text-xs font-normal capitalize">
              <span>{autoDiscountTitle}</span>
              <Price className="shrink-0" isNegative price={autoDiscountAmount} />
            </div>
          )}

          {codeDiscountAmount > 0 && (
            <div className="-mt-1 flex justify-between text-xs font-normal capitalize">
              <span>{codeDiscountTitle}</span>
              <Price isNegative price={codeDiscountAmount} />
            </div>
          )}
        </>
      )}
    </>
  );
}
